import { createGlobalStyle, css } from "styled-components";
import { BREAKPOINT_RESERVATION_PAGE } from "../../pageComponents/reservationPage/constants/breakpoints";

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'pf_highway_sans_pro_lightRg';
    src: url('//cdn.viva.gr/app/fonts/AvertaPE/regular.woff2') format('woff2'),
         url('//cdn.viva.gr/app/fonts/AvertaPE/regular.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }

  body {
    font-family: 'pf_highway_sans_pro_lightRg', sans-serif;
  }
`;

export const MoreTheme = createGlobalStyle`
    :root {
    --primaryColor: #703EFF;

    --primaryButton: #703EFF;
    --buttonText: #FFFFFF;
    --buttonTextHovered: var(--buttonText);
    --secondaryText: var(--primaryButton);
    --secondaryTextHovered: var(--tertiaryHovered);
    --secondaryTextPressed: var(--tertiaryPressed);
    --buttonHovered: #502CB5;
    --buttonPressed: #2F1A6B;
    --buttonsBorder: #703EFF;
    --tertiaryHovered: #502CB5;
    --tertiaryPressed: #2F1A6B;

    --linkPrimary: #703EFF;
    --linkHovered: #502CB5;
    --linkDark: #3E228C;
    --linkPressed: #2F1A6B;
    --linkDecoration: none;
    --lightPrimary: #F1E8FF; // light purple
    --color-purple-dark-link: #2f1a6b;
    --menuItemHovered: #F1E8FF;
    --pullerColor: #9897A9;
    --errorPageBg: linear-gradient(15deg, #daff33a4 0%, #F6FAF2 42%, #EEEAFB 55%, #DED6FA 68%, #B7A7F7 82%, #703EFF 100%);
    --delayedDeliveryBg: #F1E8FF;
    --delayedDeliveryBorder: #502CB5;
    --delayedDeliveryColor: #1f1c43;
    --delayedDeliveryIconColor: #703EFF;
    --sfTextColor: #703EFF;
    }
`;

export const OlympiacosTheme = createGlobalStyle`
    :root {
        --primaryColor: #0D0C1C;

        --primaryButton: #DC0D15;
        --buttonText: #FFFFFF;
        --buttonTextHovered: var(--buttonText);
        --secondaryText: var(--primaryButton);
        --secondaryTextHovered: var(--tertiaryHovered);
        --secondaryTextPressed: var(--tertiaryPressed);
        --buttonHovered: #AD0006;
        --buttonPressed: #AD0006;
        --buttonsBorder: #DC0D15;
        --tertiaryHovered: #AD0006;
        --tertiaryPressed: #AD0006;

        --linkPrimary: #0D0C1C;
        --linkHovered: #0D0C1C;
        --linkDark: #0D0C1C;
        --linkPressed: #0D0C1C;
        --linkDecoration: underline;
        --lightPrimary: #F3F6F9;
        --color-purple-dark-link: #0D0C1C;
        --menuItemHovered: #F3F6F9;
        --pullerColor: #A8ABAF;
        --errorPageBg: none;
        --delayedDeliveryBg: #EDF1F6;
        --delayedDeliveryBorder: #646567;
        --delayedDeliveryColor: #0D0C1C;
        --delayedDeliveryIconColor: #646567;
        --dateColor: #646567;
        --sfTextColor: #0D0C1C;
    }
`;

export const PaobcTheme = createGlobalStyle`
    :root {
        --primaryColor: #3DA862;

        --primaryButton: #3DA862;
        --buttonText: #FFFFFF;
        --buttonTextHovered: var(--buttonText);
        --secondaryText: var(--primaryButton);
        --secondaryTextHovered: var(--tertiaryHovered);
        --secondaryTextPressed: var(--tertiaryPressed);
        --buttonHovered: #5CC882;
        --buttonPressed: #296241;
        --buttonsBorder: #3DA862;
        --tertiaryHovered: #5CC882;
        --tertiaryPressed: #296241;

        --linkPrimary: #3DA862;
        --linkHovered: #5CC882;
        --linkDark: #296241;
        --linkPressed: #296241;
        --linkDecoration: none;
        --lightPrimary: rgba(62, 175, 63, 0.24);
        --color-purple-dark-link: #296241;
        --menuItemHovered: rgba(62, 175, 63, 0.24);
        --pullerColor: #A8ABAF;
        --errorPageBg: none;
        --delayedDeliveryBg: #F3F6F9;
        --delayedDeliveryBorder: #646567;
        --delayedDeliveryColor: #0D0C1C;
        --delayedDeliveryIconColor: #646567;
        --dateColor: #3DA862;
        --sfTextColor: #3DA862;
    }
`;

export const zIndexes = {
  fixedBottomBar: 1230, // above MUI drawer backdrop (1200), below MUI modal (1300)
};

export const colors = {
  primary: "var(--primaryColor)",
  primaryButton: "var(--primaryButton)",
  buttonText: "var(--buttonText)",
  buttonTextHovered: "var(--buttonTextHovered)",
  secondaryText: "var(--secondaryText)",
  secondaryTextHovered: "var(--secondaryTextHovered)",
  secondaryTextPressed: "var(--secondaryTextPressed)",
  buttonHovered: "var(--buttonHovered)",
  dark: "var(--linkDark)", //dark-purple
  lightPrimary: "var(--lightPrimary)", // hover dropdown items
  darkText: "#0D0C1C", //text -dark purple,almost black
  darkBlue: "#1F1C43", //text -dark blue
  gray: "#9897A9",
  lightGray: "#D8DBE0",
  otherGray: "#F9FBFC",
  danger: "#FC2D33", //red
  darkTitle: "#0D0C1C", //one title (Billing information) has this color
  warning: "#FCB041", //yellow
  success: "#28BE63", //green
  warningAlert: "#FFF7EC", // alert yellow
  dangerAlert: "#FFEAEB", // alert red
  linkHovered: "var(--linkHovered)", //hovered link color
  linkPressed: "var(--linkPressed)", //pressed link color
  formDefault: "#696781", //form borders default state
  formInactiveText: "#A8ABAF", //form text inactive/disabled state
  formDisabledBg: "#F7F9FB", //form background disabled state
  menuItemHovered: "var(--menuItemHovered)", // bg color on list items hover
  grayScrollbar: "#CFD1D1",
  darkGray: "#0D0C1C",
  tertiaryDefault: "var(--tertiaryDefault)",
  tertiaryHovered: "var(--tertiaryHovered)",
  tertiaryPressed: "var(--tertiaryPressed)",
  buttonsBorder: "var(--buttonsBorder)",
  pullerColor: "var(--pullerColor)",
  delayedDeliveryBg: "var(--delayedDeliveryBg)",
  delayedDeliveryBorder: "var(--delayedDeliveryBorder)",
  delayedDeliveryColor: "var(--delayedDeliveryColor)",
  delayedDeliveryIconColor: "var(--delayedDeliveryIconColor)",
  dateColor: "var(--dateColor)",
  sfTextColor: "var(--sfTextColor)"
};

export const borders = {
  lightGrayBorder: () => css`
    border: 1px solid ${colors.lightGray};
  `,
  primaryBorder: () => css`
    border: 1px solid ${colors.primary};
  `,
  darkBorder: () => css`
    border: 1px solid ${colors.dark};
  `,
  formActiveBorder: () => css`
    border: 1px solid ${colors.formDefault};
  `,
};

export const fonts = {
  title: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 20px;
    font-weight: 600;
    color: ${colors.darkText};
  `,
  midtitle: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 18px;
    font-weight: 600;
    color: ${colors.darkText};
  `,
  smallTitle: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 16px;
    font-weight: 600;
    color: ${colors.darkText};
  `,
  smallDarkGray: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 16px;
    font-weight: 600;
    color: ${colors.darkGray};
  `,
  darkPurpleTitle: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 16px;
    font-weight: 600;
    color: ${colors.dark};
  `,
  lightGrayText: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 16px;
    font-weight: 400;
    color: ${colors.gray};
  `,
  lightGrayTextSmall: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 14px;
    font-weight: 400;
    color: ${colors.lightGray};
  `,
  normalText: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 16px;
    font-weight: 400;
    color: ${colors.darkText};
  `,
  normalTextDarkGray: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 16px;
    font-weight: 400;
    color: ${colors.darkGray};
  `,
  normalTextBold: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 16px;
    font-weight: 600;
    color: ${colors.darkText};
  `,
  grayTextBold: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 16px;
    font-weight: 600;
    color: ${colors.gray};
  `,
  normalTextMedium: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 15px;
    font-weight: 400;
  `,
  normalTextSmall: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 14px;
    font-weight: 400;
    color: ${colors.darkText};
  `,
  normalTextSmallDarkGray: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 14px;
    font-weight: 400;
    color: ${colors.darkGray};
  `,
  normalTextSmallBold: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 14px;
    font-weight: 600;
    color: ${colors.darkText};
  `,
  normalTextExtraSmall: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 12px;
    font-weight: 400;
    color: ${colors.darkText};
  `,
  darkPurpleText: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 16px;
    font-weight: 400;
    color: ${colors.dark};
  `,
  purpleText: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 16px;
    font-weight: 400;
    color: ${colors.primary};
  `,
  formPlaceholder: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 16px;
    font-weight: 400;
    color: ${colors.formDefault};
  `,
  formPlaceholderSmall: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 14px;
    font-weight: 400;
    color: ${colors.formDefault};
  `,
};

export const links = {
  linkSmallBold: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 14px;
    font-weight: 600;
    color: var(--linkPrimary);
    text-decoration: var(--linkDecoration);
    cursor: pointer;

    &:hover {
      color: var(--linkDark);
      text-decoration: var(--linkDecoration);
    }
  `,
  linkNormalBold: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 16px;
    font-weight: 600;
    color: var(--linkPrimary);
    text-decoration: var(--linkDecoration);
    cursor: pointer;

    &:hover {
      color: var(--linkDark);
      text-decoration: var(--linkDecoration);
    }
    &:active {
      color: var(--linkDark);
    }

    // CSS approach to reset the color on :focus:not(:focus-visible)
    //  — this catches mouse-click focus (not keyboard focus):
    &:focus:not(:focus-visible) {
      color: ${colors.primary};
      outline: none;
    }
  `,
  linkDarkBold: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 16px;
    font-weight: 600;
    color: var(--linkDark);
    text-decoration: var(--linkDecoration);
    cursor: pointer;
    &:hover {
      text-decoration: var(--linkDecoration);
    }
  `,
  linkSmallDark: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 14px;
    font-weight: 400;
    color: var(--linkDark);
    text-decoration: var(--linkDecoration);
    cursor: pointer;

    &:hover {
      text-decoration: var(--linkDecoration);
    }
  `,
  linkNormalDark: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 16px;
    font-weight: 400;
    color: var(--linkDark);
    text-decoration: var(--linkDecoration);
    cursor: pointer;

    &:hover {
      text-decoration: var(--linkDecoration);
    }
  `,
  linkBrightPurple: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 16px;
    font-weight: 600;
    color: var(--linkPrimary);
    cursor: pointer;
    text-decoration: var(--linkDecoration);

    &:hover {
      text-decoration: var(--linkDecoration);
      color: var(--linkHovered);
    }
    &:active {
      color: var(--linkPressed);
    }
  `,
  linkSmallBrightPurple: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 14px;
    font-weight: 400;
    color: var(--linkPrimary);
    text-decoration: var(--linkDecoration);
    cursor: pointer;

    &:hover {
      text-decoration: var(--linkDecoration);
      color: var(--linkHovered);
    }
    &:active {
      color: var(--linkPressed);
    }
  `,
  linkMediumBrightPurple: () => css`
    font-family: "pf_highway_sans_pro_lightRg";
    font-size: 16px;
    font-weight: 400;
    color: var(--linkPrimary);
    text-decoration: var(--linkDecoration);
    cursor: pointer;

    &:hover {
      text-decoration: var(--linkDecoration);
      color: var(--linkHovered);
    }
    &:active {
      color: var(--linkPressed);
    }
  `,
};

export const breakpoints = {
  mobile: 600,
  tablet: 900,
  desktop: 1024,
};

export const media = {
  above: (px) => `@media (min-width: ${px}px)`,
  below: (px) => `@media (max-width: ${px - 1}px)`,
};

export const scrollbars = {
  thin: () => css`
    scrollbar-width: thin;
    scrollbar-color: ${colors.grayScrollbar} transparent;
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
      margin: 8px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: ${colors.grayScrollbar};
      border-radius: 4px;
    }

    @media (max-width: ${BREAKPOINT_RESERVATION_PAGE}) {
      font-size: 14px;
    }
  `,
};
